import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { Outlet} from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import MediationIcon from "@mui/icons-material/Mediation";
// import ExploreIcon from "@mui/icons-material/Explore";
import DiamondIcon from "@mui/icons-material/Diamond";
// import SchoolIcon from "@mui/icons-material/School";
import ContactsIcon from "@mui/icons-material/Contacts";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import CancelIcon from "@mui/icons-material/Cancel";
import MyCard from "./MyCard";
import "./responsive.css";
import { HashLink } from 'react-router-hash-link';
import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme();

theme.typography.h5 = {
  fontSize: "18px",
  "@media (min-width:600px)": {
    fontSize: "22px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "22px",
  },
};

// import HomePage from "../HomePage/HomePage/HomePage";

const drawerWidth = 240;

const navigation = [
  { name: "Home", to: "/#home", icon: <HomeIcon /> },
  { name: "About", to: "/#about", icon: <AccountBoxIcon /> },
  { name: "Skills", to: "/#skills", icon: <DiamondIcon /> },
  { name: "Projects", to: "/#projects", icon: <MediationIcon /> },
  // { name: "Experience", to: "/experience", icon: <ExploreIcon /> },
  { name: "Blogs", to: "/#blogs", icon: <AllInclusiveIcon /> },
  // { name: "Academic", to: "/academic", icon: <SchoolIcon /> },
  { name: "Contact", to: "/#contact", icon: <ContactsIcon /> },
];

function ResponsiveDrawer(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  let handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div className="CustomDrawerColor">
      <ThemeProvider theme={theme}>

      <Toolbar
      style={{marginBottom: '-45px'}}
        sx={{ display: { xs: "flex", md: "none" } }}
        onClick={(handleDrawerToggle = () => setMobileOpen(!mobileOpen))}
      >
        <Box flexGrow={1}></Box>
        <CancelIcon />
      </Toolbar>
      {/* <Toolbar /> */}
      <MyCard />

      
<Box >
  <Box sx={{  display: { xs: "flex", md: "none" } }}>      <List
        sx={{ px: 2 }}
        className="CustomDrawerColor"
        onClick={(handleDrawerToggle = () => setMobileOpen(!mobileOpen))}
      >
        {navigation.map((nav, index) => (
          <HashLink to={nav.to} style={{ textDecoration: "none" }}>
            <ListItem button key={nav.name}>
              <ListItemIcon>{nav.icon}</ListItemIcon>
              <HashLink smooth to={nav.to} style={{ textDecoration: "none" }}>
                {/* <ListItemText sx={{ color: "white" }} primary={nav.name} /> */}
                <Typography
                  variant="h5"
                  sx={{ color: "white", pl: 2 }}
                  // sx={{ color: "white", lineHeight: "1em", pl: 2 }}
                >
                  {nav.name}
                </Typography>
              </HashLink>
            </ListItem>
          </HashLink>
        ))}
      </List></Box>
     
<Box  sx={{ display: { xs: "none", md: "flex" } }}>
      <List
        sx={{ px: 1 }}
        className="CustomDrawerColor"
        // onClick={(handleDrawerToggle = () => setMobileOpen(!mobileOpen))}
      >
        {navigation.map((nav, index) => (
          <HashLink to={nav.to} style={{ textDecoration: "none" }}>
            <ListItem button key={nav.name}>
              <ListItemIcon>{nav.icon}</ListItemIcon>
              <HashLink smooth to={nav.to} style={{ textDecoration: "none" }}>
                {/* <ListItemText sx={{ color: "white" }} primary={nav.name} /> */}
                <Typography
                  variant="h5"
                  sx={{ color: "white", pl: 2 }}
                  // sx={{ color: "white", lineHeight: "1em", pl: 2 }}
                >
                  {nav.name}
                </Typography>
              </HashLink>
            </ListItem>
          </HashLink>
        ))}
      </List></Box>

</Box>


      </ThemeProvider>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
       className="drawer-toolbar" 
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar sx={{ mr: 2, display: { xs: "flex", md: "none" } }} >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            KAZI ABDUR RAKIB
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          className="CustomDrawerColor"
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {/* <Toolbar /> */}
        {/* <HomePage/> */}
        <Outlet />
      </Box>
    </Box>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
